import { render, staticRenderFns } from "./AddressEditorForm.vue?vue&type=template&id=3b537cae&scoped=true"
import script from "./AddressEditorForm.vue?vue&type=script&lang=js"
export * from "./AddressEditorForm.vue?vue&type=script&lang=js"
import style0 from "./AddressEditorForm.vue?vue&type=style&index=0&id=3b537cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b537cae",
  null
  
)

export default component.exports